export const INSTAGRAM_PROFILE_URL = "https://www.instagram.com/hellotelefonka/";

// Curated Instagram gallery
//
// When you want to feature photos from @hellotelefonka, save the selected
// Instagram images locally in the project (preferably WebP/AVIF) and add them
// to `featuredInstagramPhotos` below. Keeping the files local makes the gallery
// independent from Instagram/CDN availability and avoids fragile hotlinks.
//
// Example:
// import instagramOne from "@/assets/gallery-instagram/featured-1.webp";
// export const featuredInstagramPhotos = [
//   { src: instagramOne, width: 1200, height: 1500, altHu: "...", altEn: "...", objectPosition: "center" },
// ];
export const featuredInstagramPhotos = [];

// These WebP files are generated deterministically by scripts/prepare-media.js
// from the existing source chunks. Keeping them out of the React bundle lets
// the browser defer below-fold gallery downloads instead of paying for the
// image bytes as part of the critical JavaScript request.
export const fallbackGalleryPhotos = [
  {
    src: "/media/gallery-hero.webp",
    width: 600,
    height: 400,
    altHu: "Fehér Telefonka egy virágos mezőn",
    altEn: "White Telefonka in a flower field",
    objectPosition: "center center",
  },
  {
    src: "/media/gallery-wedding.webp",
    width: 240,
    height: 419,
    altHu: "Fehér Telefonka esküvői dekorációban, a kagylót felemelő kézzel",
    altEn: "White Telefonka in wedding decor with a hand lifting the receiver",
    objectPosition: "center 54%",
  },
  {
    src: "/media/gallery-couple.webp",
    width: 700,
    height: 467,
    altHu: "Menyasszony és vőlegény játékosan használja a fehér Telefonkát",
    altEn: "Bride and groom playfully using the white Telefonka",
    objectPosition: "center center",
  },
];

export const getGalleryPhotos = () => {
  const curated = featuredInstagramPhotos.filter((photo) => photo?.src).slice(0, 3);
  if (curated.length === 3) return curated;
  return fallbackGalleryPhotos;
};
